<script lang="ts" setup>
import { computed } from 'vue'
import type { IProps } from './Content.types'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

const props = defineProps<IProps>()

const content = computed(() => {
  return documentToHtmlString(props.content)
})
</script>

<template>
  <section class="content section-investor">
    <div
      class="section-investor__container "
      v-html="content"
    />
  </section>
</template>

<style scoped lang="scss">

.content {
  :deep(h2) {
    @include h6;
    margin-bottom: 6.4rem;
    color: $text-400;
    text-align: center;
  }

  :deep(h3) {
    @include h9;
    margin-bottom: 4.8rem;
    color: $text-400;
  }

  :deep(p) {
    @include body-2;
    margin-bottom: 2.4rem;
    color: $text-400;
  }

  :deep(blockquote) {
    p {
      @include body-2;
      margin-bottom: 2.4rem;
      color: $puls-span-text;
    }
  }

  :deep(ul) {
    padding-left: 2rem;
    list-style-type: lower-alpha;

    li::marker {
      @include body-2;
      color: $text-400;
      content: counter(list-item, lower-alpha) ") ";
    }

    p {
      margin-bottom: 0.8rem;
    }
  }
  
  :deep(hr) {
    margin: 6.4rem auto;
    border: 0;
    border-bottom: 1px solid $base-50;
  }

  :deep(ol) {
    margin-bottom: 2.4rem;
    padding-left: 0;
    list-style: none;
    counter-reset: item;

    li {
      position: relative;
      padding-left: 2.4rem;
      counter-increment: item;

      &::before {
        @include body-2;
        position: absolute;
        top: 0;
        left: 0;
        width: 2.4rem;
        color: $text-400;
        text-align: left;

        content: "(" counter(item, lower-roman) ")";
      }
    }

    p {
      margin-bottom: 0.8rem;
    }
  }

  :deep(b) {
    font-weight: 500;
  }

  @include atXS {
    :deep(h2) {
      @include h5;
    }
  }
}
</style>
